module.exports = __webpack_public_path__ + "img/vuejs.d81625aa.svg";